<template>
  <subscriptions-reports-view :userId="getUserIdFromQueryParams()" />
</template>

<script>
import SubscriptionsReportsView from "../components/reports/SubscriptionsReportsView.vue";
export default {
  components: { SubscriptionsReportsView },
  name: "Subscriptions",

  methods: {
    getUserIdFromQueryParams() {
      return this.$route.params.id;
    },
  },
};
</script>

<style scoped>
</style>
